/**
 * 이벤트 통계 목업 데이터
 * 
 * 용도: 개발/테스트 환경에서 사용할 이벤트 통계 데이터
 * 도메인: EventStatistics
 * 
 * @description 실제 API 응답과 동일한 구조를 가진 목업 데이터
 */

// 시술받은 환자 통계 데이터
export const customerResponseData = {
    "success": true,
    "data": {
        "viewOptions": {
            "messageCount": {
                "label": "메시지 건수 기준",
                "description": "재발송 포함 모든 메시지",
                "data": {
                    "메시지발송시도건수": 170160,
                    "알림톡발송성공건수": 120923,
                    "메시지발송실패건수": 3687,
                    "레퍼러로부터공유받은횟수": 173854,
                    "응모한사람": 2530,
                    "만족도만작성": 1101,
                    "후기만작성": 37,
                    "만족도후기모두작성": 1390,
                    "인증서없는응답자": 1,
                    "카카오톡공유한사람": 2901,
                    "후기남긴사람": 11079,
                    "공유후기남긴사람": 546,
                    "카카오톡공유하기횟수": 10391,
                    "이벤트페이지진입": 49184,
                    "병원페이지진입": 381,
                    "hospitalBreakdown": [
                        {
                            "hospitalId": "65026ecc83335d06c44704a7",
                            "hospitalName": "메트로안과",
                            "응모한사람": 1262,
                            "만족도/후기작성": 1043,
                            "만족도,후기모두작성": 949,
                            "후기작성완료건수": 963
                        },
                        {
                            "hospitalId": "6511397537b33bb8334c17b8",
                            "hospitalName": "밝은눈안과 강남",
                            "응모한사람": 980,
                            "만족도/후기작성": 761,
                            "만족도,후기모두작성": 684,
                            "후기작성완료건수": 690
                        },
                        {
                            "hospitalId": "65279e88426734de8916ac74",
                            "hospitalName": "온누리안과병원",
                            "응모한사람": 839,
                            "만족도/후기작성": 699,
                            "만족도,후기모두작성": 623,
                            "후기작성완료건수": 636
                        },
                        {
                            "hospitalId": "64faa472539dc1d5de81ca8f",
                            "hospitalName": "SNU안과",
                            "응모한사람": 771,
                            "만족도/후기작성": 611,
                            "만족도,후기모두작성": 571,
                            "후기작성완료건수": 576
                        },
                        {
                            "hospitalId": "650cfdafc1157deea284c296",
                            "hospitalName": "밝은세상안과",
                            "응모한사람": 630,
                            "만족도/후기작성": 527,
                            "만족도,후기모두작성": 479,
                            "후기작성완료건수": 487
                        },
                        {
                            "hospitalId": "650a86577427550d870b7131",
                            "hospitalName": "밝은누리안과병원",
                            "응모한사람": 627,
                            "만족도/후기작성": 512,
                            "만족도,후기모두작성": 455,
                            "후기작성완료건수": 459
                        },
                        {
                            "hospitalId": "6513a6d986596ebb17a664bc",
                            "hospitalName": "신세계안과",
                            "응모한사람": 576,
                            "만족도/후기작성": 457,
                            "만족도,후기모두작성": 411,
                            "후기작성완료건수": 415
                        },
                        {
                            "hospitalId": "6511413bde84400d5a7e2150",
                            "hospitalName": "온누리스마일안과의원",
                            "응모한사람": 540,
                            "만족도/후기작성": 453,
                            "만족도,후기모두작성": 420,
                            "후기작성완료건수": 425
                        },
                        {
                            "hospitalId": "650cfb15c4c4de526405131f",
                            "hospitalName": "서울밝은세상안과",
                            "응모한사람": 516,
                            "만족도/후기작성": 419,
                            "만족도,후기모두작성": 377,
                            "후기작성완료건수": 383
                        },
                        {
                            "hospitalId": "6508df7228de7f945bd8917d",
                            "hospitalName": "아이리움안과",
                            "응모한사람": 495,
                            "만족도/후기작성": 411,
                            "만족도,후기모두작성": 382,
                            "후기작성완료건수": 384
                        },
                        {
                            "hospitalId": "65111ff9c4c4de526405219b",
                            "hospitalName": "압구정안과의원",
                            "응모한사람": 464,
                            "만족도/후기작성": 392,
                            "만족도,후기모두작성": 350,
                            "후기작성완료건수": 355
                        },
                        {
                            "hospitalId": "651f9ac2de134f6965146a80",
                            "hospitalName": "GS안과",
                            "응모한사람": 452,
                            "만족도/후기작성": 427,
                            "만족도,후기모두작성": 389,
                            "후기작성완료건수": 394
                        },
                        {
                            "hospitalId": "6501653ea9417d1bcb20f387",
                            "hospitalName": "비앤빛안과",
                            "응모한사람": 353,
                            "만족도/후기작성": 234,
                            "만족도,후기모두작성": 209,
                            "후기작성완료건수": 213
                        },
                        {
                            "hospitalId": "65128e75c4c4de52640527f1",
                            "hospitalName": "인천푸른세상안과의원",
                            "응모한사람": 347,
                            "만족도/후기작성": 281,
                            "만족도,후기모두작성": 252,
                            "후기작성완료건수": 255
                        },
                        {
                            "hospitalId": "650a893df5ec194d6ea8d1e3",
                            "hospitalName": "삼성스마일안과의원",
                            "응모한사람": 317,
                            "만족도/후기작성": 266,
                            "만족도,후기모두작성": 247,
                            "후기작성완료건수": 253
                        },
                        {
                            "hospitalId": "6503e31528de7f945bd88771",
                            "hospitalName": "밝은안과21병원",
                            "응모한사람": 303,
                            "만족도/후기작성": 38,
                            "만족도,후기모두작성": 35,
                            "후기작성완료건수": 35
                        },
                        {
                            "hospitalId": "6528d1e721cead1c327b615a",
                            "hospitalName": "파티마안과",
                            "응모한사람": 302,
                            "만족도/후기작성": 251,
                            "만족도,후기모두작성": 225,
                            "후기작성완료건수": 229
                        },
                        {
                            "hospitalId": "650d2e4cc4c4de5264051458",
                            "hospitalName": "아이플러스안과의원",
                            "응모한사람": 289,
                            "만족도/후기작성": 255,
                            "만족도,후기모두작성": 226,
                            "후기작성완료건수": 227
                        },
                        {
                            "hospitalId": "651fb960de134f6965146c14",
                            "hospitalName": "강남밝은미소안과",
                            "응모한사람": 263,
                            "만족도/후기작성": 201,
                            "만족도,후기모두작성": 178,
                            "후기작성완료건수": 180
                        },
                        {
                            "hospitalId": "6527681ff9d81b753d0f4d3c",
                            "hospitalName": "더밝은안과의원",
                            "응모한사람": 257,
                            "만족도/후기작성": 230,
                            "만족도,후기모두작성": 200,
                            "후기작성완료건수": 204
                        }
                    ]
                }
            },
            "uniqueRecipient": {
                "label": "고유 수신자 기준",
                "description": "중복 제거된 실제 대상자",
                "data": {
                    "메시지발송시도건수": 170160,
                    "알림톡발송성공건수": 120923,
                    "메시지발송실패건수": 2910,
                    "레퍼러로부터공유받은횟수": 173854,
                    "응모한사람": 2530,
                    "만족도만작성": 1101,
                    "후기만작성": 37,
                    "만족도후기모두작성": 1390,
                    "카카오톡공유한사람": 2901,
                    "후기남긴사람": 11079,
                    "공유후기남긴사람": 546,
                    "카카오톡공유하기횟수": 10391,
                    "hospitalBreakdown": [
                        {
                            "hospitalId": "65026ecc83335d06c44704a7",
                            "hospitalName": "메트로안과",
                            "응모한사람": 1262,
                            "만족도/후기작성": 1043,
                            "만족도,후기모두작성": 949,
                            "후기작성완료건수": 963
                        },
                        {
                            "hospitalId": "6511397537b33bb8334c17b8",
                            "hospitalName": "밝은눈안과 강남",
                            "응모한사람": 980,
                            "만족도/후기작성": 761,
                            "만족도,후기모두작성": 684,
                            "후기작성완료건수": 690
                        },
                        {
                            "hospitalId": "65279e88426734de8916ac74",
                            "hospitalName": "온누리안과병원",
                            "응모한사람": 839,
                            "만족도/후기작성": 699,
                            "만족도,후기모두작성": 623,
                            "후기작성완료건수": 636
                        },
                        {
                            "hospitalId": "64faa472539dc1d5de81ca8f",
                            "hospitalName": "SNU안과",
                            "응모한사람": 771,
                            "만족도/후기작성": 611,
                            "만족도,후기모두작성": 571,
                            "후기작성완료건수": 576
                        },
                        {
                            "hospitalId": "650cfdafc1157deea284c296",
                            "hospitalName": "밝은세상안과",
                            "응모한사람": 630,
                            "만족도/후기작성": 527,
                            "만족도,후기모두작성": 479,
                            "후기작성완료건수": 487
                        },
                        {
                            "hospitalId": "650a86577427550d870b7131",
                            "hospitalName": "밝은누리안과병원",
                            "응모한사람": 627,
                            "만족도/후기작성": 512,
                            "만족도,후기모두작성": 455,
                            "후기작성완료건수": 459
                        },
                        {
                            "hospitalId": "6513a6d986596ebb17a664bc",
                            "hospitalName": "신세계안과",
                            "응모한사람": 576,
                            "만족도/후기작성": 457,
                            "만족도,후기모두작성": 411,
                            "후기작성완료건수": 415
                        },
                        {
                            "hospitalId": "6511413bde84400d5a7e2150",
                            "hospitalName": "온누리스마일안과의원",
                            "응모한사람": 540,
                            "만족도/후기작성": 453,
                            "만족도,후기모두작성": 420,
                            "후기작성완료건수": 425
                        },
                        {
                            "hospitalId": "650cfb15c4c4de526405131f",
                            "hospitalName": "서울밝은세상안과",
                            "응모한사람": 516,
                            "만족도/후기작성": 419,
                            "만족도,후기모두작성": 377,
                            "후기작성완료건수": 383
                        },
                        {
                            "hospitalId": "6508df7228de7f945bd8917d",
                            "hospitalName": "아이리움안과",
                            "응모한사람": 495,
                            "만족도/후기작성": 411,
                            "만족도,후기모두작성": 382,
                            "후기작성완료건수": 384
                        },
                        {
                            "hospitalId": "65111ff9c4c4de526405219b",
                            "hospitalName": "압구정안과의원",
                            "응모한사람": 464,
                            "만족도/후기작성": 392,
                            "만족도,후기모두작성": 350,
                            "후기작성완료건수": 355
                        },
                        {
                            "hospitalId": "651f9ac2de134f6965146a80",
                            "hospitalName": "GS안과",
                            "응모한사람": 452,
                            "만족도/후기작성": 427,
                            "만족도,후기모두작성": 389,
                            "후기작성완료건수": 394
                        },
                        {
                            "hospitalId": "6501653ea9417d1bcb20f387",
                            "hospitalName": "비앤빛안과",
                            "응모한사람": 353,
                            "만족도/후기작성": 234,
                            "만족도,후기모두작성": 209,
                            "후기작성완료건수": 213
                        },
                        {
                            "hospitalId": "65128e75c4c4de52640527f1",
                            "hospitalName": "인천푸른세상안과의원",
                            "응모한사람": 347,
                            "만족도/후기작성": 281,
                            "만족도,후기모두작성": 252,
                            "후기작성완료건수": 255
                        },
                        {
                            "hospitalId": "650a893df5ec194d6ea8d1e3",
                            "hospitalName": "삼성스마일안과의원",
                            "응모한사람": 317,
                            "만족도/후기작성": 266,
                            "만족도,후기모두작성": 247,
                            "후기작성완료건수": 253
                        },
                        {
                            "hospitalId": "6503e31528de7f945bd88771",
                            "hospitalName": "밝은안과21병원",
                            "응모한사람": 303,
                            "만족도/후기작성": 38,
                            "만족도,후기모두작성": 35,
                            "후기작성완료건수": 35
                        },
                        {
                            "hospitalId": "6528d1e721cead1c327b615a",
                            "hospitalName": "파티마안과",
                            "응모한사람": 302,
                            "만족도/후기작성": 251,
                            "만족도,후기모두작성": 225,
                            "후기작성완료건수": 229
                        },
                        {
                            "hospitalId": "650d2e4cc4c4de5264051458",
                            "hospitalName": "아이플러스안과의원",
                            "응모한사람": 289,
                            "만족도/후기작성": 255,
                            "만족도,후기모두작성": 226,
                            "후기작성완료건수": 227
                        },
                        {
                            "hospitalId": "651fb960de134f6965146c14",
                            "hospitalName": "강남밝은미소안과",
                            "응모한사람": 263,
                            "만족도/후기작성": 201,
                            "만족도,후기모두작성": 178,
                            "후기작성완료건수": 180
                        },
                        {
                            "hospitalId": "6527681ff9d81b753d0f4d3c",
                            "hospitalName": "더밝은안과의원",
                            "응모한사람": 257,
                            "만족도/후기작성": 230,
                            "만족도,후기모두작성": 200,
                            "후기작성완료건수": 204
                        }
                    ]
                }
            }
        },
        "defaultView": "uniqueRecipient",
        "메시지발송시도건수": 170160,
        "알림톡발송성공건수": 120923,
        "메시지발송실패건수": 2910,
        "레퍼러로부터공유받은횟수": 173854,
        "응모한사람": 2530,
        "만족도만작성": 1101,
        "후기만작성": 37,
        "만족도후기모두작성": 1390,
        "인증서없는응답자": 1,
        "카카오톡공유한사람": 2901,
        "후기남긴사람": 11079,
        "공유후기남긴사람": 546,
        "카카오톡공유하기횟수": 10391,
        "메시지요청": 151678,
        "메시지발송성공": 120923,
        "이벤트페이지진입": 49184,
        "병원페이지진입": 381,
        "messageDelivery": {
            "totalMessagesSent": 225353,
            "uniqueRecipients": 170160,
            "duplicateMessages": 55193,
            "multiRecipientCount": 54265,
            "deliveryStatus": {
                "sent": 173854,
                "failed": 3687,
                "requested": 47811
            }
        },
        "reviewResponses": {
            "totalUniqueResponders": 2530,
            "satisfactionOnlyCount": 1101,
            "reviewTextOnlyCount": 37,
            "bothCompletedCount": 1390,
            "abnormalDataCount": 602
        },
        "surgeryCategories": {
            "uncategorizedResponders": 1
        },
        "reviewDocuments": {
            "totalReviewTexts": 11079,
            "reviewTextRate": "437.7%"
        }
    },
    "metadata": {
        "eventId": "6864f97c93111a68978dc3f5",
        "timestamp": "2025-09-23T13:41:15.815Z",
        "period": {
            "startDate": null,
            "endDate": null,
            "isFullPeriod": true
        },
        "dataSource": {
            "메시지통계": "eventattendees.messageSendHistory",
            "응답자통계": "reviews (satisfactionPoints/content)",
            "수술타입": "reviews.categoryName"
        },
        "dataQuality": {
            "completeness": "76.2%",
            "calculation": {
                "formula": "(전체응답자 - 비정상응답) / 전체응답자 * 100",
                "values": {
                    "전체응답자": 2530,
                    "비정상응답": 602,
                    "정상응답": 1928
                },
                "description": "만족도나 후기 중 하나라도 작성한 정상 응답자의 비율"
            }
        }
    }
};

// 환자의 친구 통계 데이터
export const customerFriendResponseData = {
    "success": true,
    "data": {
        "viewOptions": {
            "messageCount": {
                "label": "메시지 건수 기준",
                "description": "재발송 포함 모든 메시지",
                "data": {
                    "메시지발송시도건수": 319,
                    "알림톡발송성공건수": 0,
                    "메시지발송실패건수": 0,
                    "레퍼러로부터공유받은횟수": 10391,
                    "응모한사람": 3534,
                    "만족도만작성": 0,
                    "후기만작성": 70,
                    "만족도후기모두작성": 0,
                    "인증서없는응답자": 0,
                    "카카오톡공유한사람": 791,
                    "후기남긴사람": 6,
                    "공유후기남긴사람": 1,
                    "카카오톡공유하기횟수": 952,
                    "이벤트페이지진입": 12832,
                    "병원페이지진입": 787,
                    "hospitalBreakdown": [
                        {
                            "hospitalId": "6511397537b33bb8334c17b8",
                            "hospitalName": "밝은눈안과 강남",
                            "응모한사람": 47,
                            "만족도/후기작성": 1,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 1
                        },
                        {
                            "hospitalId": "64faa472539dc1d5de81ca8f",
                            "hospitalName": "SNU안과",
                            "응모한사람": 27,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "65026ecc83335d06c44704a7",
                            "hospitalName": "메트로안과",
                            "응모한사람": 24,
                            "만족도/후기작성": 2,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 3
                        },
                        {
                            "hospitalId": "650cfdafc1157deea284c296",
                            "hospitalName": "밝은세상안과",
                            "응모한사람": 21,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "6513a6d986596ebb17a664bc",
                            "hospitalName": "신세계안과",
                            "응모한사람": 20,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "6503e31528de7f945bd88771",
                            "hospitalName": "밝은안과21병원",
                            "응모한사람": 19,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "650a86577427550d870b7131",
                            "hospitalName": "밝은누리안과병원",
                            "응모한사람": 19,
                            "만족도/후기작성": 2,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 2
                        },
                        {
                            "hospitalId": "673d2c82406f510f70729c51",
                            "hospitalName": "주식회사 서티라이프",
                            "응모한사람": 17,
                            "만족도/후기작성": 17,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 35
                        },
                        {
                            "hospitalId": "6501653ea9417d1bcb20f387",
                            "hospitalName": "비앤빛안과",
                            "응모한사람": 14,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "651e679a362cd2325fd04d58",
                            "hospitalName": "BGN밝은눈안과병원",
                            "응모한사람": 14,
                            "만족도/후기작성": 1,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 1
                        },
                        {
                            "hospitalId": "6511413bde84400d5a7e2150",
                            "hospitalName": "온누리스마일안과의원",
                            "응모한사람": 13,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "650cfb15c4c4de526405131f",
                            "hospitalName": "서울밝은세상안과",
                            "응모한사람": 12,
                            "만족도/후기작성": 1,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 1
                        },
                        {
                            "hospitalId": "6526125fcb5423406f1b346e",
                            "hospitalName": "삼성미라클안과의원 강남",
                            "응모한사람": 10,
                            "만족도/후기작성": 2,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 3
                        },
                        {
                            "hospitalId": "651fb960de134f6965146c14",
                            "hospitalName": "강남밝은미소안과",
                            "응모한사람": 10,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "65278430f9d81b753d0f50ff",
                            "hospitalName": "BGN밝은눈안과",
                            "응모한사람": 9,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "65279e88426734de8916ac74",
                            "hospitalName": "온누리안과병원",
                            "응모한사람": 9,
                            "만족도/후기작성": 1,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 1
                        },
                        {
                            "hospitalId": "6508df7228de7f945bd8917d",
                            "hospitalName": "아이리움안과",
                            "응모한사람": 9,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "6528d1e721cead1c327b615a",
                            "hospitalName": "파티마안과",
                            "응모한사람": 8,
                            "만족도/후기작성": 1,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 1
                        },
                        {
                            "hospitalId": "65092adc7427550d870b6ff5",
                            "hospitalName": "강남조은눈안과",
                            "응모한사람": 8,
                            "만족도/후기작성": 1,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 1
                        },
                        {
                            "hospitalId": "6513c20b5b7da9746efaf27f",
                            "hospitalName": "센트럴윤길중안과의원",
                            "응모한사람": 6,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        }
                    ]
                }
            },
            "uniqueRecipient": {
                "label": "고유 수신자 기준",
                "description": "중복 제거된 실제 대상자",
                "data": {
                    "메시지발송시도건수": 319,
                    "알림톡발송성공건수": 0,
                    "메시지발송실패건수": 0,
                    "레퍼러로부터공유받은횟수": 10391,
                    "응모한사람": 3534,
                    "만족도만작성": 0,
                    "후기만작성": 70,
                    "만족도후기모두작성": 0,
                    "카카오톡공유한사람": 791,
                    "후기남긴사람": 6,
                    "공유후기남긴사람": 1,
                    "카카오톡공유하기횟수": 952,
                    "hospitalBreakdown": [
                        {
                            "hospitalId": "6511397537b33bb8334c17b8",
                            "hospitalName": "밝은눈안과 강남",
                            "응모한사람": 47,
                            "만족도/후기작성": 1,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 1
                        },
                        {
                            "hospitalId": "64faa472539dc1d5de81ca8f",
                            "hospitalName": "SNU안과",
                            "응모한사람": 27,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "65026ecc83335d06c44704a7",
                            "hospitalName": "메트로안과",
                            "응모한사람": 24,
                            "만족도/후기작성": 2,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 3
                        },
                        {
                            "hospitalId": "650cfdafc1157deea284c296",
                            "hospitalName": "밝은세상안과",
                            "응모한사람": 21,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "6513a6d986596ebb17a664bc",
                            "hospitalName": "신세계안과",
                            "응모한사람": 20,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "6503e31528de7f945bd88771",
                            "hospitalName": "밝은안과21병원",
                            "응모한사람": 19,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "650a86577427550d870b7131",
                            "hospitalName": "밝은누리안과병원",
                            "응모한사람": 19,
                            "만족도/후기작성": 2,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 2
                        },
                        {
                            "hospitalId": "673d2c82406f510f70729c51",
                            "hospitalName": "주식회사 서티라이프",
                            "응모한사람": 17,
                            "만족도/후기작성": 17,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 35
                        },
                        {
                            "hospitalId": "6501653ea9417d1bcb20f387",
                            "hospitalName": "비앤빛안과",
                            "응모한사람": 14,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "651e679a362cd2325fd04d58",
                            "hospitalName": "BGN밝은눈안과병원",
                            "응모한사람": 14,
                            "만족도/후기작성": 1,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 1
                        },
                        {
                            "hospitalId": "6511413bde84400d5a7e2150",
                            "hospitalName": "온누리스마일안과의원",
                            "응모한사람": 13,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "650cfb15c4c4de526405131f",
                            "hospitalName": "서울밝은세상안과",
                            "응모한사람": 12,
                            "만족도/후기작성": 1,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 1
                        },
                        {
                            "hospitalId": "6526125fcb5423406f1b346e",
                            "hospitalName": "삼성미라클안과의원 강남",
                            "응모한사람": 10,
                            "만족도/후기작성": 2,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 3
                        },
                        {
                            "hospitalId": "651fb960de134f6965146c14",
                            "hospitalName": "강남밝은미소안과",
                            "응모한사람": 10,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "65278430f9d81b753d0f50ff",
                            "hospitalName": "BGN밝은눈안과",
                            "응모한사람": 9,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "65279e88426734de8916ac74",
                            "hospitalName": "온누리안과병원",
                            "응모한사람": 9,
                            "만족도/후기작성": 1,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 1
                        },
                        {
                            "hospitalId": "6508df7228de7f945bd8917d",
                            "hospitalName": "아이리움안과",
                            "응모한사람": 9,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "6528d1e721cead1c327b615a",
                            "hospitalName": "파티마안과",
                            "응모한사람": 8,
                            "만족도/후기작성": 1,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 1
                        },
                        {
                            "hospitalId": "65092adc7427550d870b6ff5",
                            "hospitalName": "강남조은눈안과",
                            "응모한사람": 8,
                            "만족도/후기작성": 1,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 1
                        },
                        {
                            "hospitalId": "6513c20b5b7da9746efaf27f",
                            "hospitalName": "센트럴윤길중안과의원",
                            "응모한사람": 6,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        }
                    ]
                }
            }
        },
        "defaultView": "uniqueRecipient",
        "메시지발송시도건수": 319,
        "알림톡발송성공건수": 0,
        "메시지발송실패건수": 0,
        "레퍼러로부터공유받은횟수": 10391,
        "응모한사람": 3534,
        "만족도만작성": 0,
        "후기만작성": 70,
        "만족도후기모두작성": 0,
        "인증서없는응답자": 0,
        "카카오톡공유한사람": 791,
        "후기남긴사람": 6,
        "공유후기남긴사람": 1,
        "카카오톡공유하기횟수": 952,
        "메시지요청": 0,
        "메시지발송성공": 0,
        "이벤트페이지진입": 12832,
        "병원페이지진입": 787,
        "messageDelivery": {
            "totalMessagesSent": 319,
            "uniqueRecipients": 319,
            "duplicateMessages": 0,
            "multiRecipientCount": 0,
            "deliveryStatus": {
                "sent": 0,
                "failed": 0,
                "requested": 319
            }
        },
        "reviewResponses": {
            "totalUniqueResponders": 3534,
            "satisfactionOnlyCount": 0,
            "reviewTextOnlyCount": 70,
            "bothCompletedCount": 0,
            "abnormalDataCount": 3464
        },
        "surgeryCategories": {
            "uncategorizedResponders": 0
        },
        "reviewDocuments": {
            "totalReviewTexts": 70,
            "reviewTextRate": "2.0%"
        }
    },
    "metadata": {
        "eventId": "6864f97c93111a68978dc3f5",
        "timestamp": "2025-09-23T13:41:31.325Z",
        "period": {
            "startDate": null,
            "endDate": null,
            "isFullPeriod": true
        },
        "dataSource": {
            "메시지통계": "eventattendees.messageSendHistory",
            "응답자통계": "reviews (satisfactionPoints/content)",
            "수술타입": "reviews.categoryName"
        },
        "dataQuality": {
            "completeness": "2.0%",
            "calculation": {
                "formula": "(전체응답자 - 비정상응답) / 전체응답자 * 100",
                "values": {
                    "전체응답자": 3534,
                    "비정상응답": 3464,
                    "정상응답": 70
                },
                "description": "만족도나 후기 중 하나라도 작성한 정상 응답자의 비율"
            }
        }
    }
};

// 친구의 친구 통계 데이터
export const friendOfFriendResponseData = {
    "success": true,
    "data": {
        "viewOptions": {
            "messageCount": {
                "label": "메시지 건수 기준",
                "description": "재발송 포함 모든 메시지",
                "data": {
                    "메시지발송시도건수": 7572,
                    "알림톡발송성공건수": 0,
                    "메시지발송실패건수": 0,
                    "레퍼러로부터공유받은횟수": 952,
                    "응모한사람": 25944,
                    "만족도만작성": 0,
                    "후기만작성": 0,
                    "만족도후기모두작성": 0,
                    "인증서없는응답자": 0,
                    "카카오톡공유한사람": 3816,
                    "후기남긴사람": 0,
                    "공유후기남긴사람": 0,
                    "카카오톡공유하기횟수": 5312,
                    "이벤트페이지진입": 157508,
                    "병원페이지진입": 10359,
                    "hospitalBreakdown": [
                        {
                            "hospitalId": "673d2c82406f510f70729c51",
                            "hospitalName": "주식회사 서티라이프",
                            "응모한사람": 1340,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 35
                        },
                        {
                            "hospitalId": "64b9d3bfb794cf4a93e5d8f7",
                            "hospitalName": "[테스트] 서티치과",
                            "응모한사람": 502,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "651285c6c4c4de526405275c",
                            "hospitalName": "카이안과",
                            "응모한사람": 268,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "6524d308362cd2325fd05901",
                            "hospitalName": "[테스트] 자이스안과",
                            "응모한사람": 5,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 1
                        },
                        {
                            "hospitalId": "65128e75c4c4de52640527f1",
                            "hospitalName": "인천푸른세상안과의원",
                            "응모한사람": 4,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "65026ecc83335d06c44704a7",
                            "hospitalName": "메트로안과",
                            "응모한사람": 3,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 3
                        },
                        {
                            "hospitalId": "6508df7228de7f945bd8917d",
                            "hospitalName": "아이리움안과",
                            "응모한사람": 2,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "6503e31528de7f945bd88771",
                            "hospitalName": "밝은안과21병원",
                            "응모한사람": 2,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "651f9ac2de134f6965146a80",
                            "hospitalName": "GS안과",
                            "응모한사람": 2,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "6501653ea9417d1bcb20f387",
                            "hospitalName": "비앤빛안과",
                            "응모한사람": 2,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "655d6c2d258e21eed3ca2f29",
                            "hospitalName": "아이백안과",
                            "응모한사람": 2,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "65111ff9c4c4de526405219b",
                            "hospitalName": "압구정안과의원",
                            "응모한사람": 2,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "65279e88426734de8916ac74",
                            "hospitalName": "온누리안과병원",
                            "응모한사람": 1,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 1
                        },
                        {
                            "hospitalId": "650a86577427550d870b7131",
                            "hospitalName": "밝은누리안과병원",
                            "응모한사람": 1,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 2
                        },
                        {
                            "hospitalId": "6528b0a47440b04c6838745f",
                            "hospitalName": "김기수수안과의원",
                            "응모한사람": 1,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "6527681ff9d81b753d0f4d3c",
                            "hospitalName": "더밝은안과의원",
                            "응모한사람": 1,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "650927c47427550d870b6fb3",
                            "hospitalName": "강남서울밝은안과",
                            "응모한사람": 1,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "65701e2f28b782855b46e6be",
                            "hospitalName": "천안나안과",
                            "응모한사람": 1,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "650cfdafc1157deea284c296",
                            "hospitalName": "밝은세상안과",
                            "응모한사람": 1,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "650d2e4cc4c4de5264051458",
                            "hospitalName": "아이플러스안과의원",
                            "응모한사람": 1,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        }
                    ]
                }
            },
            "uniqueRecipient": {
                "label": "고유 수신자 기준",
                "description": "중복 제거된 실제 대상자",
                "data": {
                    "메시지발송시도건수": 7567,
                    "알림톡발송성공건수": 0,
                    "메시지발송실패건수": 0,
                    "레퍼러로부터공유받은횟수": 952,
                    "응모한사람": 25944,
                    "만족도만작성": 0,
                    "후기만작성": 0,
                    "만족도후기모두작성": 0,
                    "카카오톡공유한사람": 3816,
                    "후기남긴사람": 0,
                    "공유후기남긴사람": 0,
                    "카카오톡공유하기횟수": 5312,
                    "hospitalBreakdown": [
                        {
                            "hospitalId": "673d2c82406f510f70729c51",
                            "hospitalName": "주식회사 서티라이프",
                            "응모한사람": 1340,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 35
                        },
                        {
                            "hospitalId": "64b9d3bfb794cf4a93e5d8f7",
                            "hospitalName": "[테스트] 서티치과",
                            "응모한사람": 502,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "651285c6c4c4de526405275c",
                            "hospitalName": "카이안과",
                            "응모한사람": 268,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "6524d308362cd2325fd05901",
                            "hospitalName": "[테스트] 자이스안과",
                            "응모한사람": 5,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 1
                        },
                        {
                            "hospitalId": "65128e75c4c4de52640527f1",
                            "hospitalName": "인천푸른세상안과의원",
                            "응모한사람": 4,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "65026ecc83335d06c44704a7",
                            "hospitalName": "메트로안과",
                            "응모한사람": 3,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 3
                        },
                        {
                            "hospitalId": "6508df7228de7f945bd8917d",
                            "hospitalName": "아이리움안과",
                            "응모한사람": 2,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "6503e31528de7f945bd88771",
                            "hospitalName": "밝은안과21병원",
                            "응모한사람": 2,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "651f9ac2de134f6965146a80",
                            "hospitalName": "GS안과",
                            "응모한사람": 2,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "6501653ea9417d1bcb20f387",
                            "hospitalName": "비앤빛안과",
                            "응모한사람": 2,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "655d6c2d258e21eed3ca2f29",
                            "hospitalName": "아이백안과",
                            "응모한사람": 2,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "65111ff9c4c4de526405219b",
                            "hospitalName": "압구정안과의원",
                            "응모한사람": 2,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "65279e88426734de8916ac74",
                            "hospitalName": "온누리안과병원",
                            "응모한사람": 1,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 1
                        },
                        {
                            "hospitalId": "650a86577427550d870b7131",
                            "hospitalName": "밝은누리안과병원",
                            "응모한사람": 1,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 2
                        },
                        {
                            "hospitalId": "6528b0a47440b04c6838745f",
                            "hospitalName": "김기수수안과의원",
                            "응모한사람": 1,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "6527681ff9d81b753d0f4d3c",
                            "hospitalName": "더밝은안과의원",
                            "응모한사람": 1,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "650927c47427550d870b6fb3",
                            "hospitalName": "강남서울밝은안과",
                            "응모한사람": 1,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "65701e2f28b782855b46e6be",
                            "hospitalName": "천안나안과",
                            "응모한사람": 1,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "650cfdafc1157deea284c296",
                            "hospitalName": "밝은세상안과",
                            "응모한사람": 1,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        },
                        {
                            "hospitalId": "650d2e4cc4c4de5264051458",
                            "hospitalName": "아이플러스안과의원",
                            "응모한사람": 1,
                            "만족도/후기작성": 0,
                            "만족도,후기모두작성": 0,
                            "후기작성완료건수": 0
                        }
                    ]
                }
            }
        },
        "defaultView": "uniqueRecipient",
        "메시지발송시도건수": 7567,
        "알림톡발송성공건수": 0,
        "메시지발송실패건수": 0,
        "레퍼러로부터공유받은횟수": 952,
        "응모한사람": 25944,
        "만족도만작성": 0,
        "후기만작성": 0,
        "만족도후기모두작성": 0,
        "인증서없는응답자": 0,
        "카카오톡공유한사람": 3816,
        "후기남긴사람": 0,
        "공유후기남긴사람": 0,
        "카카오톡공유하기횟수": 5312,
        "메시지요청": 0,
        "메시지발송성공": 0,
        "이벤트페이지진입": 157508,
        "병원페이지진입": 10359,
        "messageDelivery": {
            "totalMessagesSent": 7572,
            "uniqueRecipients": 7567,
            "duplicateMessages": 5,
            "multiRecipientCount": 2,
            "deliveryStatus": {
                "sent": 0,
                "failed": 0,
                "requested": 7572
            }
        },
        "reviewResponses": {
            "totalUniqueResponders": 25944,
            "satisfactionOnlyCount": 0,
            "reviewTextOnlyCount": 0,
            "bothCompletedCount": 0,
            "abnormalDataCount": 25944
        },
        "surgeryCategories": {
            "uncategorizedResponders": 0
        },
        "reviewDocuments": {
            "totalReviewTexts": 70,
            "reviewTextRate": "0.3%"
        }
    },
    "metadata": {
        "eventId": "6864f97c93111a68978dc3f5",
        "timestamp": "2025-09-23T13:47:21.174Z",
        "period": {
            "startDate": null,
            "endDate": null,
            "isFullPeriod": true
        },
        "dataSource": {
            "메시지통계": "eventattendees.messageSendHistory",
            "응답자통계": "reviews (satisfactionPoints/content)",
            "수술타입": "reviews.categoryName"
        },
        "dataQuality": {
            "completeness": "0.0%",
            "calculation": {
                "formula": "(전체응답자 - 비정상응답) / 전체응답자 * 100",
                "values": {
                    "전체응답자": 25944,
                    "비정상응답": 25944,
                    "정상응답": 0
                },
                "description": "만족도나 후기 중 하나라도 작성한 정상 응답자의 비율"
            }
        }
    }
}
